export class AbortFetchRequest {
  public instance?: AbortController
  constructor() {
    this.resetOrStartAbortController()
  }
  resetOrStartAbortController() {
    if (this.instance) {
      delete this.instance
    }
    this.instance = new AbortController()
  }

  getInstance() {
    if (!this.instance) {
      this.instance = new AbortController()
    }
    return this.instance
  }

  abortFetchRequest() {
    if (this.instance) {
      this.instance.abort()
      this.resetOrStartAbortController()
    }
  }
}
